
import React, { useEffect, useState } from 'react';
import { config } from '../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../CommonUtils/CommonAxios';
import * as bie from "react-bootstrap";
import { FaCheck, FaFilePdf, FaReceipt, FaTimes, FaWpforms } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Letter_to_Registrar from "./FFCANonOamdc/Letter_to_Registrar.docx";
import aff_coll_nonoamdc from "./FFCANonOamdc/aff_coll.apk";
import aff_coll_oamdc from "./FFCANonOamdc/DegreeInspection.apk";

import { FcAndroidOs } from "react-icons/fc";
import { useDispatch } from 'react-redux';
import { viewImage } from '../CommonUtils/viewImage';

export default function Dashboard() {
    const dispatch = useDispatch();
    const userId = sessionStorage.getItem('user_id');
    const acYear = sessionStorage.getItem('ac_year');
    const Collegetype = sessionStorage.getItem('loginType'); // "college" or "ffca" or "university"
    const [currentStep, setCurrentStep] = useState(0);
    const [ffcacurrentStep, setffcaCurrentStep] = useState(0);


    const [statusObj, setStatusObj] = useState({});
    let navigate = useNavigate();
    const [clgtype, setClgtype] = useState('');
    function GetOAMDCClgType() {
        let url = config.url.API_URL + `getOamdcType`
        CommonAxiosGet(url).then((res) => {
            if (res?.data) {
                setClgtype(res?.data)

            } else {
                setClgtype([])
            }
        })
    }
    function GetData() {
        CommonAxiosGet(`${config.url.API_URL}getclgRegStatus`)
            .then(res => {
                if (res?.data?.scode === '01' && res.data.clgStatus?.[0]) {
                    const obj = res.data.clgStatus[0];
                    setStatusObj(obj);
                    setCurrentStep(computeCurrentStep(obj, flow));
                } else {
                    setStatusObj({});
                    setCurrentStep(0);
                }
            })
            .catch(() => {
                setStatusObj({});
                setCurrentStep(0);
            });
    }


    const collegeFlow = {
        titles: [
            "Approval", "Application", "Society", "College Details", "Society Land Allotments",
            "Geo Location", "College Building Related", "Building Blocks", "Instructional Area",
            "Administrative Area", "Class Room Area Calculation", "Course Intake", "Academic Performance",
            "Teaching Staff", "Non Teaching Staff", "Lab Area", "Lab course Mapping", "Lab Equipment",
            "College Facilities", "Other Infrastructural", "Financial Details", "Fee Status",
            "Affidavit Upload Pdf"
        ],
        fieldMap: {
            approval: 0, application: 1, society: 2, clgdetails: 3, land: 4,
            geolocation: 5, bldrelated: 6, bldblocks: 7, instarea: 8, admarea: 9,
            clsroom: 10, coures: 11, acper: 12, tch: 13, nontch: 14,
            labarea: 15, labmap: 16, quip: 17, facilities: 18, infra: 19,
            finance: 20, fee: 21, affidavit: 22
        }
    };

    const degreeFlow = {
        titles: [
            "College  Approval Details", "Building Blocks", "Instructional Area",
            "Teaching Staff", "Lab Area", "Lab course Mapping", "Final Submission"
        ],
        fieldMap: {
            clgdetails: 0, bldblocks: 1, instarea: 2, tch: 3,
            labarea: 4, labmap: 5, submission: 6
        }
    };



    const FFCANonOamdc = {
        titles: [
            "Membership Section",
            "Fee Due to University",
            "Link Upload",
            "Geo Location",
            "Building Blocks",
            "Instructional Area",
            "Administrative Area",
            "Lab Area",
            "Questionnaire Section-I",
            "Questionnaire Section-II",
            "Questionnaire Section-III",
            "Questionnaire Section-IV",
            "FFCA Deficiencies",
            "Feedback/Final Submission",
        ],
        fieldMap: {
            ffca_mem_section: 0,
            fee_due_univ: 1,
            ffca_link_upload: 2,
            ffca_geo_location: 3,
            ffca_build_blocks: 4,
            ffca_instruct_area: 5,
            ffca_admin_area: 6,
            ffca_lab_area: 7,
            ffca_ques_sect_1: 8,
            ffca_ques_sect_2: 9,
            ffca_ques_sect_3: 10,
            ffca_ques_sect_4: 11,
            ffca_deficiencies: 12,
            ffca_remarks: 13,
        }
    };


    const FFCAOamdc = {
        titles: [
            "Membership Section",
            "Committee Photos",
            "Plinth Area",
            "Faculty Availability",
            "Lab Availability ",
            "Document Remarks",
            "OAMDC Remarks",
            "College App Details",
            "Classroom Uploads",
            "Lab Uploads",
            "Building Uploads",
            "Library Uploads",
            "Playground Uploads",
            "Parking Area Uploads",
            "Registered Deed Details",
            "FFCA Deficiencies",
            "Feedback/Final Submission"
        ],
        fieldMap: {
            affl_ffca_member_details: 0,
            affl_ffca_committe_photos: 1,
            affl_ffca_plinth_area: 2,
            affl_ffca_faculty_availability: 3,
            affl_ffca_lab_availability_remarks: 4,
            affl_ffca_document_remarks: 5,
            affl_oamdc_ffca_remarks: 6,
            affl_ffca_coll_details_app: 7,
            affl_ffca_coll_clsroom_uploads: 8,
            affl_ffca_coll_lab_uploads: 9,
            affl_ffca_coll_building_uploads: 10,
            affl_ffca_coll_library_uploads: 11,
            affl_ffca_coll_playgrnd_uploads: 12,
            affl_ffca_coll_parkingarea_uploads: 13,
            affl_inspection_data_details: 14,
            affl_ffca_deficiencies: 15,
            affl_final_recomm: 16
        }
    };


    function computeCurrentStep(status, { fieldMap, titles }) {
        for (const [field, idx] of Object.entries(fieldMap)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return titles.length;
    }



    function GetFfcadashboardData() {
        const url = `${config.url.API_URL}getFfcaSectionStatus`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                const rawObj = res.data.getFfcaSectionStatus[0];
                // Normalize keys to remove `_status`
                const normalizedObj = {};
                for (const key in rawObj) {
                    if (key.endsWith('_status')) {
                        const baseKey = key.replace('_status', '');
                        normalizedObj[baseKey] = rawObj[key];
                    }
                    else {
                        normalizedObj[key] = rawObj[key];
                    }
                }

                setStatusObj(normalizedObj);
                setffcaCurrentStep(computeCurrentStep(normalizedObj, FFCADashboardFlow));
            } else {
                setStatusObj({});
                setffcaCurrentStep(0);
            }
        });
    }


    useEffect(() => {
        if (Collegetype === "ffca") {
            GetFfcadashboardData();
        } else {
            GetData();
        }
        GetOAMDCClgType();

    }, [Collegetype]);
    const flow = clgtype === "oamdc" ? degreeFlow : collegeFlow;

    const FFCADashboardFlow = clgtype === "oamdc" ? FFCAOamdc : FFCANonOamdc;


    function computeCurrentStep(status, { fieldMap, titles }) {
        for (const [field, idx] of Object.entries(fieldMap)) {
            if (status[field] !== 'Done') {
                return idx + 1;
            }
        }
        return titles.length;
    }



    const handleClick = () => {
        navigate("/PaymentReceipt");
    };
    const NavtoApprovalProceeding = () => {
        navigate("/AfflApprovalProceedingsUpload")

    }

    // function GetPdfoamdc() {
    //     let payload = {}
    //     let url = config.url.API_URL + `getdegreepdf/${userId}/${acYear}`
    //     CommonAxiosPost(url, payload, dispatch).then((res) => {
    //         if (res?.data?.Status === true) {
    //             viewImage(res?.data?.path)
    //         }
    //         else {
    //             console.log(res);
    //         }
    //     })
    // }
    const FinalClgSubmissionPdfUrl = clgtype === "oamdc" ? config.url.API_URL + `getdegreepdf/${userId}/${acYear}` : config.url.API_URL + `getAffiliationPdf/` + userId + "/" + acYear;

    function GetPDF(title) {
        let payload = {}
        // let url = config.url.API_URL + `getAffiliationPdf/` + userId + "/" + acYear;
        CommonAxiosPost(FinalClgSubmissionPdfUrl, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }
    return (
        <>

            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                {
                    Collegetype !== "university" && Collegetype === "college" && (<>
                        {Collegetype !== "ffca" && (<>

                            <div className="inner-herbpage-service-title1">
                                <h5 className="mb-0">
                                    <h5 className="mb-0">College Application Status,AcYear {acYear}</h5>
                                </h5>
                            </div>
                        </>)}

                        <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
                            <h1 className='mb-0'>College Name: <span>{statusObj?.inst_name}</span></h1>
                            <h1 className='mb-0 ms-4'>College Code: <span>{statusObj?.coll_code}</span></h1>
                        </div>
                    </>)}

                {Collegetype !== "ffca" && Collegetype !== "university" && (<>
                    <bie.Container fluid className="pt-5">
                        <div className="horizontal-stepper-wrapper">
                            {flow.titles.map((title, idx) => {
                                const stepIndex = idx + 1;
                                const fieldKey = Object.keys(flow.fieldMap)
                                    .find(key => flow.fieldMap[key] === idx);
                                const isDone = statusObj[fieldKey] === 'Done' ? "Done" : "Not Done";
                                const isActive = stepIndex === currentStep;
                                return (
                                    <div key={idx} className="stepper-item">
                                        <div className={`step-icon ${isDone === "Done" ? 'completed' : isActive ? 'active' : 'pending'}`}>
                                            {/* {stepIndex} */}

                                            {idx === flow.titles.length - 1 ? (<>
                                                {/* <img src="../img/downloadgif.gif" alt="icrs image" class=".img-responsive" width={"100%"} /> */}

                                                <div
                                                    tabIndex={0}               // make div focusable
                                                    onKeyDown={(e) => {
                                                        if (e.key === 'Enter' || e.key === ' ') {
                                                            e.preventDefault();
                                                            GetPDF();
                                                        }
                                                    }}
                                                    className="pdf-icon"
                                                    style={{ color: 'white', cursor: 'pointer', fontSize: "16px" }}
                                                    onClick={() => GetPDF(title)}
                                                    title="View PDF"
                                                >
                                                    {/* <img src="../img/down3.gif" alt="download pdf" class=".img-responsive" height={75} width={"100%"} /> */}

                                                    <FaFilePdf size={25} />
                                                </div>
                                            </>) : (
                                                stepIndex
                                            )}
                                        </div>
                                        <button type="button"
                                            className={`step-title ${isDone === "Done" ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}
                                            onClick={() => setCurrentStep(stepIndex)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {title}
                                        </button>
                                        <div className="step-badge">
                                            <bie.Badge bg={isDone === "Done" ? "success" : isDone === "Not Done" ? "danger" : ""}>
                                                {isDone === "Done" ? <FaCheck className="me-1" /> : isDone === "Not Done" ? <FaTimes className="me-1" /> : ""}
                                                {isDone === "Done" ? 'Done' : isDone === "Not Done" ? 'Not Done' : ""}
                                            </bie.Badge>
                                        </div>


                                        {/* {(title === "Affidavit Upload" || title === "Final Submission") && (
                                            <FaFilePdf
                                                className="pdf-icon"
                                                style={{ color: 'red', cursor: 'pointer', marginTop: '5px' }}
                                                onClick={() => GetPDF(title)}
                                                title="View PDF"

                                            />
                                        )} */}

                                        {idx !== flow.titles.length - 1 && (
                                            <div className={`step-line-horizontal ${isDone === "Done" ? 'line-completed-horizontal' : ''}`}></div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>

                    </bie.Container>
                    <br /><br /><br />


                    <div className="d-flex justify-content-center mb-5">

                        <a style={{ color: "red", fontSize: "24px", align: "center", marginBottom: "1rem", }} onClick={() => {
                            handleClick();
                        }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter' || e.key === ' ') {
                                    e.preventDefault();
                                    handleClick();
                                }
                            }}
                        >
                            <FaReceipt size={32} style={{ color: '#dc3545' }} /> Click here to Download Payment Receipt</a></div>
                    {/* {Collegetype === "college" && (<center>
                        <button type="button" style={{ color: "brown", textDecoration: "underline", fontSize: "20px" }} onClick={NavtoApprovalProceeding}>Upload AICTE Proceedings   ( If BBA/BCA Courses are available)</button>
                    </center>)} */}

                </>)}

                {/* && clgtype === "Nonoamdc"  */}
                {Collegetype === "ffca" ? (<>
                    <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                        <div className="inner-herbpage-service-title-sub pt-0 mb-3 d-flex align-items-center">
                            <h1 className="mb-0">
                                College Name: <span>{statusObj.inst_name}</span>
                            </h1>
                            <h1 className="mb-0 ms-4">
                                College Code: <span>{statusObj.coll_code}</span>
                            </h1>
                        </div>
                        <bie.Container fluid className="pt-5">
                            <div className="horizontal-stepper-wrapper">
                                {FFCADashboardFlow?.titles?.map((title, idx) => {
                                    const ffcaStepIndex = idx + 1;
                                    const fieldKey = Object.keys(FFCADashboardFlow?.fieldMap)
                                        .find(key => FFCADashboardFlow?.fieldMap[key] === idx);
                                    const isDone = statusObj[fieldKey] === 'Done' ? "Done" : "Not Done";
                                    const isActive = ffcaStepIndex === ffcacurrentStep;

                                    return (
                                        <div key={idx} className="stepper-item">
                                            <div className={`step-icon ${isDone == "Done" ? 'completed' : isActive ? 'active' : 'pending'}`}>
                                                {ffcaStepIndex}
                                            </div>
                                            <button
                                                type="button"
                                                className={`step-title ${isDone === "Done" ? 'label-done' : ''} ${isActive ? 'active-label' : ''}`}
                                                onClick={() => setffcaCurrentStep(ffcaStepIndex)}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                {title}
                                            </button>
                                            <div className="step-badge">
                                                <bie.Badge bg={isDone === "Done" ? "success" : isDone === "Not Done" ? "danger" : ""}>
                                                    {isDone === "Done" ? <FaCheck className="me-1" /> : isDone === "Not Done" ? <FaTimes className="me-1" /> : ""}
                                                    {isDone === "Done" ? 'Done' : isDone === "Not Done" ? 'Not Done' : ""}
                                                </bie.Badge>
                                            </div>
                                            {idx !== FFCADashboardFlow?.titles?.length - 1 && (
                                                <div className={`step-line-horizontal ${isDone == "Done" ? 'line-completed-horizontal' : ''}`}></div>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </bie.Container>
                        <br />
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>

                                <a href={Letter_to_Registrar} style={{ color: "#a83264", fontSize: "18px", fontFamily: "sans-serif" }} target="_blank" rel="noopener noreferrer">
                                    <FaWpforms size={25} />   Click here to download Undertaking Letter</a>
                            </bie.Col>
                            {clgtype == "Nonoamdc" && Collegetype === "ffca" && (<>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>

                                    <a href={aff_coll_nonoamdc} style={{ color: "#a83264", fontSize: "18px", fontFamily: "sans-serif" }} rel="noopener noreferrer">
                                        <FcAndroidOs size={25} />   Click here to download FFCA COLLEGE LOCATOR APP    </a>
                                </bie.Col>
                            </>)}
                            {clgtype == "oamdc" && Collegetype === "ffca" && (<>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={6}>

                                    <a href={aff_coll_oamdc} style={{ color: "#a83264", fontSize: "18px", fontFamily: "sans-serif" }} rel="noopener noreferrer">
                                        <FcAndroidOs size={25} />    Click here to download FFCA COLLEGE APP    </a>
                                </bie.Col>
                            </>)}

                        </bie.Row>
                    </bie.Container >

                </>) : (<></>)
                }

            </bie.Container >
        </>
    );
}





